(() => {
  const SELECTOR='.cdd-drawer-component';
  const STORAGE_KEY='cdd:delivery-date:'+window.location.hostname;

  const getParts=(date,timeZone,options)=>Object.fromEntries(
    new Intl.DateTimeFormat('en-GB',{timeZone,...options}).formatToParts(date)
      .filter(p=>p.type!=='literal').map(p=>[p.type,p.value])
  );
  const toUTCDate=value=>{const [y,m,d]=value.split('-').map(Number);return new Date(Date.UTC(y,m-1,d));};
  const toISO=date=>[date.getUTCFullYear(),String(date.getUTCMonth()+1).padStart(2,'0'),String(date.getUTCDate()).padStart(2,'0')].join('-');
  const storageGet=()=>{try{return sessionStorage.getItem(STORAGE_KEY)||'';}catch(e){return'';}};
  const storageSet=v=>{try{sessionStorage.setItem(STORAGE_KEY,v);}catch(e){}};
  const storageRemove=()=>{try{sessionStorage.removeItem(STORAGE_KEY);}catch(e){}};

  const minimumISO=root=>{
    const tz=root.dataset.timezone||'Europe/London';
    const d=getParts(new Date(),tz,{year:'numeric',month:'2-digit',day:'2-digit'});
    const t=getParts(new Date(),tz,{hour:'2-digit',minute:'2-digit',hourCycle:'h23'});
    const date=toUTCDate([d.year,d.month,d.day].join('-')); const hour=Number(t.hour);
    if(date.getUTCDay()===6) date.setUTCDate(date.getUTCDate()+2);
    else if(date.getUTCDay()===5&&hour>=12) date.setUTCDate(date.getUTCDate()+3);
    else date.setUTCDate(date.getUTCDate()+(hour>=12?2:1));
    return toISO(date);
  };
  const formatDate=value=>new Intl.DateTimeFormat('en-GB',{timeZone:'UTC',weekday:'long',day:'numeric',month:'long',year:'numeric'}).format(toUTCDate(value));
  const isWeekend=value=>[0,6].includes(toUTCDate(value).getUTCDay());

  const closePicker=root=>{
    const picker=root.querySelector('.cdd-picker-modal');
    if(picker){picker.hidden=true;picker.setAttribute('aria-hidden','true');}
    const row=root.querySelector('.cdd-date-row');
    if(row)row.setAttribute('aria-expanded','false');
  };

  const renderCalendar=(root,selected)=>{
    const picker=root.querySelector('.cdd-picker-modal'),title=root.querySelector('.cdd-picker-title'),days=root.querySelector('.cdd-picker-days'),prev=root.querySelector('[data-cdd-prev]'),next=root.querySelector('[data-cdd-next]');
    if(!picker||!title||!days)return;
    const min=minimumISO(root);
    let view=root.dataset.calendarMonth||selected||min;
    const viewDate=toUTCDate(view); viewDate.setUTCDate(1); root.dataset.calendarMonth=toISO(viewDate);
    title.textContent=new Intl.DateTimeFormat('en-GB',{timeZone:'UTC',month:'long',year:'numeric'}).format(viewDate);
    days.innerHTML='';
    const first=(viewDate.getUTCDay()+6)%7;
    for(let i=0;i<first;i++){const blank=document.createElement('span');blank.className='cdd-picker-empty';days.appendChild(blank);}
    const y=viewDate.getUTCFullYear(),m=viewDate.getUTCMonth(),last=new Date(Date.UTC(y,m+1,0)).getUTCDate();
    for(let day=1;day<=last;day++){
      const value=toISO(new Date(Date.UTC(y,m,day))),button=document.createElement('button');
      button.type='button';button.className='cdd-picker-day';button.textContent=String(day);
      if(value===selected)button.classList.add('is-selected');
      if(isWeekend(value))button.classList.add('is-weekend');
      if(value<min)button.disabled=true;else button.dataset.cddDate=value;
      days.appendChild(button);
    }
    const minMonth=toUTCDate(min);minMonth.setUTCDate(1);prev.disabled=viewDate<=minMonth;next.disabled=false;
  };

  const openPicker=root=>{
    const picker=root.querySelector('.cdd-picker-modal');if(!picker)return;
    const min=minimumISO(root),stored=storageGet(),selected=stored&&stored>=min?stored:min;
    renderCalendar(root,selected);picker.hidden=false;picker.setAttribute('aria-hidden','false');
    const row=root.querySelector('.cdd-date-row');if(row)row.setAttribute('aria-expanded','true');
  };

  const chooseDate=(root,value)=>{
    const min=minimumISO(root);if(!value||value<min)return;
    const text=root.querySelector('.cdd-date-button-text'),modal=root.querySelector('.cdd-modal');
    if(text)text.textContent=formatDate(value);
    if(isWeekend(value)){
      root.dataset.pendingDate=value;root.dataset.confirmedDate='';closePicker(root);
      if(modal){modal.hidden=false;modal.setAttribute('aria-hidden','false');}
    }else{
      root.dataset.pendingDate='';root.dataset.confirmedDate=value;storageSet(value);closePicker(root);
    }
  };

  const refreshRoot=root=>{
    const text=root.querySelector('.cdd-date-button-text');if(!text)return;
    const min=minimumISO(root),stored=storageGet();
    if(stored&&stored>=min){root.dataset.confirmedDate=stored;text.textContent=formatDate(stored);}
    else if(stored){storageRemove();delete root.dataset.confirmedDate;text.textContent='Select delivery date';}
  };

  const init=()=>document.querySelectorAll(SELECTOR).forEach(root=>refreshRoot(root));

  if(!window.__cddPermanentDateEvents){
    window.__cddPermanentDateEvents=true;

    document.addEventListener('click',event=>{
      const row=event.target.closest(SELECTOR+' .cdd-date-row');
      if(row){
        const root=row.closest(SELECTOR);
        if(root){event.preventDefault();event.stopPropagation();openPicker(root);}
        return;
      }

      const dateButton=event.target.closest(SELECTOR+' .cdd-picker-day[data-cdd-date]');
      if(dateButton){
        const root=dateButton.closest(SELECTOR);
        if(root){event.preventDefault();event.stopPropagation();chooseDate(root,dateButton.dataset.cddDate);}
        return;
      }

      const close=event.target.closest(SELECTOR+' [data-cdd-picker-close]');
      if(close){
        const root=close.closest(SELECTOR);
        if(root){event.preventDefault();closePicker(root);}
        return;
      }

      const prev=event.target.closest(SELECTOR+' [data-cdd-prev]');
      if(prev){
        const root=prev.closest(SELECTOR);
        if(root){event.preventDefault();const d=toUTCDate(root.dataset.calendarMonth||minimumISO(root));d.setUTCMonth(d.getUTCMonth()-1);root.dataset.calendarMonth=toISO(d);renderCalendar(root,root.dataset.confirmedDate||minimumISO(root));}
        return;
      }

      const next=event.target.closest(SELECTOR+' [data-cdd-next]');
      if(next){
        const root=event.target.closest(SELECTOR);
        if(root){
          event.preventDefault();
          event.stopPropagation();
          const d=toUTCDate(root.dataset.calendarMonth||minimumISO(root));
          d.setUTCMonth(d.getUTCMonth()+1);
          root.dataset.calendarMonth=toISO(d);
          renderCalendar(root,root.dataset.confirmedDate||minimumISO(root));
        }
        return;
      }

      const accept=event.target.closest(SELECTOR+' [data-cdd-accept]');
      if(accept){
        const root=accept.closest(SELECTOR),value=root&&root.dataset.pendingDate;
        if(root&&value){event.preventDefault();event.stopPropagation();root.dataset.confirmedDate=value;root.dataset.pendingDate='';storageSet(value);const modal=root.querySelector('.cdd-modal');if(modal){modal.hidden=true;modal.setAttribute('aria-hidden','true');}const text=root.querySelector('.cdd-date-button-text');if(text)text.textContent=formatDate(value);}
      }
    },true);
  }

  const installCartMutationGuard=()=>{
    if(window.__cddCartMutationGuard) return;
    window.__cddCartMutationGuard=true;

    const isCartMutation=(url)=>{
      try{
        const value=typeof url==='string' ? url : (url&&url.url)||'';
        return /\/cart\/(change|update|clear)(\.js)?(?:\?|$)/i.test(value);
      }catch(e){return false;}
    };

    if(typeof window.fetch==='function'){
      const originalFetch=window.fetch.bind(window);
      window.fetch=(input,init)=>{
        const url=typeof input==='string' ? input : (input&&input.url)||'';
        if(isCartMutation(url)) storageRemove();
        return originalFetch(input,init);
      };
    }

    if(window.XMLHttpRequest){
      const OriginalXHR=window.XMLHttpRequest;
      const open=OriginalXHR.prototype.open;
      OriginalXHR.prototype.open=function(method,url){
        this.__cddCartMutation=isCartMutation(url);
        return open.apply(this,arguments);
      };
      const send=OriginalXHR.prototype.send;
      OriginalXHR.prototype.send=function(){
        if(this.__cddCartMutation) storageRemove();
        return send.apply(this,arguments);
      };
    }
  };

  const clearIfCartEmpty=async()=>{
    try{const r=await fetch('/cart.js',{credentials:'same-origin',cache:'no-store'});if(!r.ok)return;const cart=await r.json();if(Number(cart.item_count)!==0)return;storageRemove();document.querySelectorAll(SELECTOR).forEach(root=>{delete root.dataset.confirmedDate;delete root.dataset.pendingDate;const text=root.querySelector('.cdd-date-button-text');if(text)text.textContent='Select delivery date';closePicker(root);});}catch(e){}
  };

  const hasConfirmedDate=()=>{
    return Array.from(document.querySelectorAll(SELECTOR)).some(root=>{
      const input=root.querySelector('.cdd-date-button-text');
      const stored=root.dataset.confirmedDate||'';
      return !!stored &&
        stored>=minimumISO(root) &&
        input &&
        input.textContent.trim()!=='Select delivery date';
    });
  };
  const hasOpenWeekendPopup=()=>Array.from(document.querySelectorAll(SELECTOR+' .cdd-modal')).some(m=>!m.hidden);
  const blockCheckoutIfNeeded=()=>{
    if(hasOpenWeekendPopup()){alert('Please press Accept to confirm your weekend delivery date before checkout.');return true;}
    if(hasConfirmedDate())return false;
    alert('Please select a delivery date before checkout.');
    const field=document.querySelector(SELECTOR+' .cdd-date-row');if(field)field.scrollIntoView({behavior:'smooth',block:'center'});return true;
  };

  if(!window.__cddCheckoutValidation){
    window.__cddCheckoutValidation=true;
    document.addEventListener('submit',e=>{const s=e.submitter;if(s&&(s.id==='checkout'||s.name==='checkout')&&blockCheckoutIfNeeded())e.preventDefault();},true);
    document.addEventListener('click',e=>{const t=e.target.closest('button#checkout,button[name="checkout"],a[href*="/checkout"]');if(t&&blockCheckoutIfNeeded()){e.preventDefault();e.stopImmediatePropagation();}},true);
  }

  if(!window.__cddCartStateWatch){
    window.__cddCartStateWatch=true;
    document.addEventListener('cart:updated',clearIfCartEmpty);
    document.addEventListener('shopify:cart:lines-update',clearIfCartEmpty);
  }

  installCartMutationGuard();
  init();
  window.addEventListener('pageshow',init);window.addEventListener('focus',init);
  document.addEventListener('visibilitychange',()=>{if(document.visibilityState==='visible')init();});
  document.addEventListener('shopify:section:load',init);
  document.addEventListener('cart:updated',init);
  document.addEventListener('shopify:cart:lines-update',init);
  document.addEventListener('shopify:cart:view',init);
})();

/* Homepage Fruits & Vegetables banner: make the entire banner clickable. */
(() => {
  const initFreshBannerLink = () => {
    const banner = document.querySelector('#shopify-section-rich_text_c34HJ7 .rich-text__wrapper, .section-rich_text_c34HJ7 .rich-text__wrapper');
    if (!banner || banner.dataset.freshBannerLinked === 'true') return;
    banner.dataset.freshBannerLinked = 'true';
    banner.style.cursor = 'pointer';
    banner.setAttribute('role', 'link');
    banner.setAttribute('tabindex', '0');
    banner.setAttribute('aria-label', 'Shop Fresh Vegetables');

    const go = () => {
      window.location.href = '/collections/fresh-vegetables';
    };

    banner.addEventListener('click', (event) => {
      if (event.target.closest('a, button, input, select, textarea')) return;
      event.preventDefault();
      event.stopPropagation();
      go();
    }, true);

    banner.addEventListener('keydown', (event) => {
      if (event.key === 'Enter' || event.key === ' ') {
        event.preventDefault();
        go();
      }
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initFreshBannerLink);
  } else {
    initFreshBannerLink();
  }

  document.addEventListener('shopify:section:load', initFreshBannerLink);
})();

/* Homepage Sweets banner: make the entire banner clickable. */
(() => {
  const initSweetsBannerLink = () => {
    const banner = document.querySelector('#shopify-section-rich_text_DAMkbi .rich-text__wrapper, .section-rich_text_DAMkbi .rich-text__wrapper');
    if (!banner || banner.dataset.sweetsBannerLinked === 'true') return;

    banner.dataset.sweetsBannerLinked = 'true';
    banner.style.cursor = 'pointer';
    banner.setAttribute('role', 'link');
    banner.setAttribute('tabindex', '0');
    banner.setAttribute('aria-label', 'Shop Sweets');

    const go = () => {
      window.location.href = '/collections/sweets';
    };

    banner.addEventListener('click', (event) => {
      if (event.target.closest('a, button, input, select, textarea')) return;
      event.preventDefault();
      event.stopPropagation();
      go();
    }, true);

    banner.addEventListener('keydown', (event) => {
      if (event.key === 'Enter' || event.key === ' ') {
        event.preventDefault();
        go();
      }
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initSweetsBannerLink);
  } else {
    initSweetsBannerLink();
  }

  document.addEventListener('shopify:section:load', initSweetsBannerLink);
})();

/* Reliable delegated homepage banner links. */
(() => {
  if (window.__nammaHomepageBannerLinks) return;
  window.__nammaHomepageBannerLinks = true;
  const routes = [
    { selector: '.section-rich_text_c34HJ7, #shopify-section-rich_text_c34HJ7, [id$="__rich_text_c34HJ7"]', url: '/collections/fresh-vegetables' },
    { selector: '.section-rich_text_DAMkbi, #shopify-section-rich_text_DAMkbi, [id$="__rich_text_DAMkbi"]', url: '/collections/sweets' }
  ];
  const findBanner = (target) => {
    for (const item of routes) {
      const banner = target.closest(item.selector);
      if (banner) return item;
    }
    return null;
  };
  document.addEventListener('click', (event) => {
    const item = findBanner(event.target);
    if (!item) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    window.location.assign(item.url);
  }, true);
  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Enter' && event.key !== ' ') return;
    const item = findBanner(event.target);
    if (!item) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    window.location.assign(item.url);
  }, true);
})();